import muster from '@dbk-legacy/muster';
import { variable, redirectOn } from '@dbk-legacy/muster/helpers';
import { getValues, ref, call } from '@dbk-legacy/muster/utils';
import { Platform, AsyncStorage } from 'react-native';
export default () => {
  return muster()
    .path('feedback.sendResponse', {
      call: async ({ req }, { get, set, call }) => {
        await set('feedback.displayMsg', "");
        await set('feedback.ratingFeedback', false);
        let { deviceType, starRating, feedbackCateg, feedbackText, logoutTriggered, clientAdvisorFlag } = req.args[0].input;
        const [messages] = await getValues(get('i18n.messages'));
        if (starRating > 0) {
          await set('feedback.ratingFeedback', true);
        }
        var [portfolioId] = await getValues(get('app.user.selectedPortfolioId'));
        let [oReturn] = "";
        if (starRating == 0) {
          feedbackText = "feedbackText-" + feedbackText;
          [oReturn] = await getValues(get(`roster.data.feedback.getResponseJson["${portfolioId}"]["${deviceType}"]["${starRating}"]["${feedbackCateg.split(' ').join('-')}"]["${feedbackText.split(' ').join('-')}"]["${logoutTriggered}"]["${clientAdvisorFlag.split(' ').join('-')}"]`));
        }
        else {
          [oReturn] = await getValues(get(`roster.data.feedback.getStarFeedback["${portfolioId}"]["${deviceType}"]["${starRating}"]["${feedbackCateg}"]["${feedbackText}"]["${logoutTriggered}"]["${clientAdvisorFlag.split(' ').join('-')}"]`));
        }
        if (oReturn.$type == "error") {
          await set('feedback.displayMsg', messages['app.feedback.submit']);
          await set('feedback.success', false);
          return;
        }
        const oResult = JSON.parse(oReturn);
        if (oResult.status && oResult.status.toUpperCase() == "SUCCESS") {
          await set('feedback.displayMsg', messages['app.rating.subTitle']);
          await set('feedback.success', true);
        }
        else {
          await set('feedback.displayMsg', messages['app.feedback.submit']);
          await set('feedback.success', false);
        }
      },
    })

    .path('feedback.checkStarFeedback', {
      call: async ({ req }, { get, set, call }) => {
        await set('feedback.checkStatus', "loading");
        const [oReturn] = await getValues(get(`roster.data.feedback.checkStarFeedback`));
        if (oReturn.$type == "error") {
          await set('feedback.checkStatus', "fail");
          return;
        }
        const oResult = JSON.parse(oReturn);
        if (oResult.showStarFeedback && oResult.showStarFeedback == true) {
          await set('feedback.checkStatus', "success");
        }
        else {
          await set('feedback.checkStatus', "fail");
        }
      },
    })


    .path('feedback.checkUserType', {
      call: async ({ req }, { get, set, call }) => {
        await set('feedback.usertype', "");
        const [oReturn] = await getValues(get(`roster.data.feedback.checkUserType`));
        const oResult = JSON.parse(oReturn);
        if (oReturn.$type == "error") {
          await set('feedback.usertype', " ");
          return;
        }
        if (oResult.userGroup == 95) {
          await set('feedback.usertype', "RM Relationship Manager");
        }
        else if (oResult.userGroup == 96) {
          await set('feedback.usertype', "EPM External Portfolio Manager");
        }
        else if (oResult.userGroup == 12) {
          await set('feedback.usertype', "PWM IT Support");
        }
        else if (oResult.userGroup == 20) {
          await set('feedback.usertype', "Regular Customer");
        }
        else if (oResult.userGroup == 10) {
          await set('feedback.usertype', "Client Admin");
        }
        else if (oResult.userGroup == 11) {
          await set('feedback.usertype', "ID Admin");
        }
        else if (oResult.userGroup == 25) {
          await set('feedback.usertype', "Authorised Person");
        }
        else if (oResult.userGroup == 21) {
          await set('feedback.usertype', "Service Assistant");
        }
      },
    })

    .path('feedback.success', variable(false))
    .path('feedback.ratingFeedback', variable(false))
    .path('feedback.checkStatus', variable(""))
    .path('feedback.usertype', variable(""))
    .path('feedback.displayMsg', variable(""));
}